module.exports = __webpack_public_path__ + "static/media/am.06509258.svg";